export default {
    ACTIVE: "active",
    ACTIVENOURL: "activeNoUrl",
    INGRACEPERIOD: "inGracePeriod",
    CANCELED: "canceled",
    PREVENTEDCHRS: [32,92,47,39,34,44,46, 59, 124, 62, 60, 35, 63, 91, 93, 123, 125, 37, 33, ],
    SLINK_YEARLY_PLAN: {plan: process.env.SLINK_YEARLY_PLAN, price: '19.99'},
    PACK3_PLAN: {plan: process.env.PACK3_PLAN, price: '5.99'},
    "status": {
        "SlinkNotRequested": {
          "shortCode": "snr",
          "longCode": "SlinkNotRequested",
          "message": "Slink Not Requested"
        },
        "SlinkNotFound": {
          "shortCode": "snf",
          "longCode": "SlinkNotFound",
          "message": "Slink Not Found"
        },
        "SubSlinkNotFound": {
          "shortCode": "sbnf",
          "longCode": "SubSlinkNotFound",
          "message": "SubSlink NoT Found"
        },
        "SlinkExistsNoUrl": {
          "shortCode": "nu",
          "longCode": "SlinkExistsNoUrl",
          "message": "Slink Exists No URL"
        },
        "SlinkInGracePeriod": {
          "shortCode": "gp",
          "longCode": "SlinkInGracePeriod",
          "message": "Slink In Grace Period"
        },
        "SlinkPendingPurchase": {
          "shortCode": "spp",
          "longCode": "SlinkPendingPurchase",
          "message": "Slink Pending Purchase"
        },
        "SlinkPendingCancel": {
          "shortCode": "spc",
          "longCode": "SlinkPendingCancel",
          "message": "Slink Pending Cancel"
        },
        "SlinkActive": {
          "shortCode": "active",
          "longCode": "SlinkActive",
          "message": "Slink Active"
        },
        "CartNotFound":{
          "shortCode": "cnf",
          "longCode": "CartNotFound",
          "message": "Cart Not Found"
        },
        "AccountNotFound":{
          "shortCode": "anf",
          "longCode": "AccountNotFound",
          "message": "Account Not Found"
        },
        "TokenNotFound":{
          "shortCode": "tnf",
          "longCode": "TokenNotFound",
          "message": "Token Not Found"
        }
      },
      "plans": {
        "LargeMonthly":{
          "shortCode": "Pro/Mthly",
          "longCode": "Pro / Monthly",
        },
        "MediumMonthly":{
          "shortCode": "Pers/Mthly",
          "longCode": "Personal / Monthly",
        },
        "SmallMonthly":{
          "shortCode": "Basic/Mthly",
          "longCode": "Basic / Monthly",
        },

        "LargeYearly":{
          "shortCode": "Pro/Yrly",
          "longCode": "Pro / Monthly",
        },
        "MediumYearly":{
          "shortCode": "Pers/Yrly",
          "longCode": "Personal / Monthly",
        },
        "SmallYearly":{
          "shortCode": "Basic/Yrly",
          "longCode": "Basic / Monthly",
        },
      }
      
}


// WEBPACK FOOTER //
// ./src/STATIC/constants.js